module.exports = __webpack_public_path__ + "img/examination-bg.a45ffc83.png";